import { FormValidator, type FormValidatorConfig, type FormValidatorSettings } from '../models';
import { isEmpty } from '../utils';

export interface MaxValidatorSettings extends FormValidatorSettings {
  max: number;
  equalEnabled: boolean;
  formatMax?: (max: number) => string;
  formatBeforeValidation?: (value: any) => number;
}

export type MaxValidatorConfig = FormValidatorConfig<MaxValidatorSettings>;

export class MaxValidator extends FormValidator<MaxValidatorSettings> {
  constructor() {
    super();
    this._name = 'max';
    this._settings = {
      max: 0,
      equalEnabled: true,
      invalidMessage: 'form.validator.max.invalidMessage',
      needTranslate: true
    };
  }

  public override async onValidate(value: any) {
    if (isEmpty(value)) {
      this.reset();
      return;
    }

    const formattedValue = this._settings.formatBeforeValidation ? this._settings.formatBeforeValidation(value) : value;

    this._valid = this._settings.equalEnabled
      ? this._settings.max >= formattedValue
      : this._settings.max > formattedValue;

    if (!this._valid) {
      let maxString = this._settings.max.toString();
      if (this._settings.formatMax) {
        maxString = this._settings.formatMax(this._settings.max);
      }

      this.addMessage(this._settings.invalidMessage, 'error', { max: maxString });
    }
  }
}
